import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { AppForm, AuthorizationService, Comment, Commentable, CommentService } from '@ng-cloud/badger-core';
import { TranslatePipe } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FieldErrorsComponent } from '../../common/field-errors/field-errors.component';
import { FormErrorsComponent } from '../../common/form-errors/form-errors.component';
import { FormFieldComponent } from '../../common/form-field/form-field.component';

@Component({
  selector: 'bt-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrls: ['./comment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FieldErrorsComponent,
    FormErrorsComponent,
    FormFieldComponent,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    TranslatePipe
  ]
})
export class CommentFormComponent implements OnInit {
  form: AppForm<Comment>;
  formGroup: UntypedFormGroup;
  comment: Comment;
  commentable: Commentable;
  existingComment: boolean;
  isError = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CommentFormComponent>,
    public dialog: MatDialog,
    protected authService: AuthorizationService,
    protected commentService: CommentService
  ) {
    this.comment = data.comment;
    this.commentable = data.commentable;
    this.formGroup = this.createFormGroup();
    this.form = new AppForm(
      this.formGroup,
      this.comment,
      new Comment(),
      (comment) => this.onSuccess(comment)
    );
  }

  ngOnInit() {
    if (this.comment.id) {
      this.existingComment = true;
    }
  }

  createFormGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      userId: new UntypedFormControl(
        this.authService.getCurrentUserId(),
        Validators.required
      ),
      body: new UntypedFormControl(this.comment.body, Validators.required)
    });
  }

  onSuccess(comment: Comment) {
    if (!this.isError) {
      this.dialogRef.close(comment);
    }
  }

  create() {
    if (this.existingComment) {
      this.form.submit((comment) =>
        this.commentService.updateComment(comment).pipe(
          tap((updatedComment) => {
            console.debug('Comment updated successfully.:', updatedComment);
          }),
          catchError((err) => {
            this.isError = true;
            console.error('Error updating comment:', err);
            return of(null);
          })
        )
      );
    }
    else {
      this.form.submit((comment) =>
        this.commentService.createComment(comment, this.commentable).pipe(
          tap((createdComment) => {
            console.debug('Comment created successfully.:', createdComment);
          }),
          catchError((err) => {
            this.isError = true;
            console.error('Error creating comment:', err);
            return of(null);
          })
        )
      );
    }
    this.formGroup.reset();
  }
}
